module.exports = __webpack_public_path__ + "assets/img/8_1620_big.f80254c3.jpg";